<template>
  <div class="page-login">
    <form class="login" v-on:submit.prevent="logIn">
      <div class="logo">
        <img src="../assets/img/logo_green.png" alt="logo" />
      </div>

      <div class="beta">
        <img src="../assets/img/beta.svg" alt="logo" />
      </div>

      <label>
        <input type="text" name="login" placeholder="Login" v-model="loginForm.login"/>
      </label>

      <label>
        <input type="password" name="password" placeholder="Password" v-model="loginForm.password"/>
      </label>

      <button class="button" type="submit" @click="logIn">Sign In</button>

      <div class="error">{{error}}</div>
    </form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loginForm: {
          login: '',
          password: ''
        },
        error: '',
      }
    },
    methods: {
      async logIn() {
        if (!this.loginForm.login) {
          this.error = 'Поле Login должно быть заполнено';

          return false;
        }

        if (!this.loginForm.password) {
          this.error = 'Поле Password должно быть заполнено';

          return false;
        }

        this.loginForm.login = this.loginForm.login.trim();
        this.loginForm.password = this.loginForm.password.trim();

        try {
          await this.$store.dispatch('LOG_IN', this.loginForm);
        } catch (e) {
          if (e.response && e.response.data && e.response.data.error) {
            this.error = e.response.data.error;
          } else {
            this.error = 'Сервис временно недоступен';
          }
        }

        return false;
      }
    }
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables.scss";

  .page-login {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: $dark;
    border-bottom: 5px solid $secondary;

    .login {
      display: block;
      position: absolute;
      top: 50%;
      width: 100%;
      margin-top: -150px;

      .logo {
        height: 20px;
        margin: 0 0 5px;
        text-align: center;

        img {
          height: 100%;
        }
      }

      .beta {
        height: 22px;
        margin: 0 0 60px;
        text-align: center;

        img {
          height: 100%;
        }
      }

      label {
        display: block;
        margin: 0 0 20px;
        text-align: center;

        input {
          height: 30px;
          padding: 5px 10px;
          line-height: 30px;
          color: $dark;
          background-color: $secondary;
          border: 1px solid $secondary;
          border-radius: 20px;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
        }

        ::placeholder {
          color: $dark;
        }
      }

      .button {
        display: block;
        width: 100px;
        margin: 60px auto 0;
        font-weight: bold;
        font-size: 12px;
        text-align: center;
        text-transform: uppercase;
        color: $secondary;
        cursor: pointer;
        background: none;
        border: none;
        border: 0;
        outline:none;
      }

      .error {
        text-align: center;
        color: $text-error;
      }
    }
  }
</style>
